import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpclientService } from "../../../shared/services/httpclient.service";

@Injectable()
export class Course2Service {
	constructor(private httpclientService: HttpclientService) {}
	loadCourse2List(applicationItemID, schoolID) {
		var postResult$ = new Subject();
		var url = "Report/Course2GetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
